import queryString from 'query-string';
import {DOMParser} from 'xmldom';
import Url from 'url-parse';

export function processCmsContentForGameMode(rawContent, mode, pagesInGame = []) {
    let dom = null;
    if (!rawContent) return rawContent;
    if (mode !== 'iosgame' && mode !== 'game') return rawContent;
    try {
        const parser = new DOMParser();
        dom = parser.parseFromString(rawContent, 'text/html');
        const anchors = dom.getElementsByTagName('a');
        const {length} = anchors;
        for (let i = 0; i < length; i++) {
            const anchor = anchors[i];
            const href = anchor.getAttribute('href');
            if (href) {
                const hrefObj = new Url(href);
                const isEpicUrl =
                    hrefObj.hostname.indexOf('epicgames.com') !== -1 ||
                    hrefObj.hostname.indexOf('epicgames.net') !== -1;
                let isWhilteListed = false;
                if (isEpicUrl) {
                    // only try to match paths if it's an epic url
                    for (const pagePath of pagesInGame) {
                        if (hrefObj.pathname.indexOf(pagePath) !== -1) {
                            isWhilteListed = true;
                            break;
                        }
                    }
                }
                if (isEpicUrl && isWhilteListed) {
                    // game page needs to process all links and add the request parameter to the privacy policy and fan content policy
                    const queryObj = queryString.parse(hrefObj.query);
                    const newQueryObj = {
                        ...queryObj,
                        mode
                    };
                    hrefObj.query = queryString.stringify(newQueryObj);
                    anchor.setAttribute('href', hrefObj.toString());
                } else {
                    // game page needs to "unlink" all other links on the page when mode=game by changing the <a> tags into <span> tags
                    anchor.tagName = 'span';
                    anchor.localName = 'span';
                    anchor.nodeName = 'span';
                    anchor.setAttribute('style', 'filter: grayscale(1)');
                }
            }
        }
        return dom.toString();
    } catch (ex) {
        console.error('Failed to processHtml()', ex);
        return rawContent;
    }
}
